import { ITimetable } from '../../interfaces/ITimetable'
import { apiUrl_, GetUserType } from '../config'
import { ISchoolFees } from '../../interfaces/ISchoolFees'
import myAxios from '../myAxios'
import { ISchool } from '../../interfaces/school.interface'
import { AccountUserPlansType } from '../../components/AccountUser/interfaces/IAccountUserPlan'
import { IColorScheme } from '@/components/SchoolDetailsComponents/IColorScheme'
import { IBulkStudent } from '@/components/Students/AddBulkStudent/AddBulkStudent'

const user_type = typeof localStorage !== 'undefined' && GetUserType()
const user_is_school_admin = user_type === 'admin'

const myBaseUrl = apiUrl_
const myBaseCouponUrl = `${myBaseUrl}/schools/api/v2/coupons`
const myBaseUsersUrl = `${myBaseUrl}/users/api/v1`
const myCourseTeamUrl = `${myBaseUrl}/course-teams/v2`
const myBaseCustomDomainUrl = `${myBaseUrl}/schools/custom-domains/api/v1`
const myBaseSchoolUrl = `${myBaseUrl}/schools/users/api/v1`
const myBaseSchoolAuthUrl = `${myBaseUrl}/schools/auth/api/v1`
const myBaseClassUrl = `${myBaseUrl}/single_class/users/api/v1`
// if user is logged in as an admin use /schools/admins else if user is an account from account-dashboard use /schools/user-admin/
const myBaseAdminUrl = `${myBaseUrl}/schools/${
  user_is_school_admin ? 'admins' : 'users-admin'
}/api/v1`
const myBaseAdminTeacherUrl = myBaseUrl + '/courses/v1/admin-tea'
const myBaseMarketingUrl = `${myBaseUrl}/schools/communications/api/v1`

export const AddNewStudentRequest = (opts: {
  name: String
  email: String
  schoolId: String
  customAuthInput: any
  password: string
}) => {
  return myAxios.post(
    `${myBaseAdminUrl}/students/?school_id=${opts.schoolId}`,
    {
      student_name: opts.name,
      student_email: opts.email,
      custom_auth_input: opts.customAuthInput,
      password: opts.password,
    },
  )
}

export const AddBulkStudentRequest = (opts: {
  students: IBulkStudent[]
  schoolId: string
}) => {
  return myAxios.post(
    `${myBaseAdminUrl}/bulk-students/?school_id=${opts.schoolId}`,
    {
      students: opts.students,
    },
  )
}

export const DeleteBulkStudentRequest = (opts: {
  studentIds: string[]
  schoolId: string
}) => {
  return myAxios.post(
    `${myBaseAdminUrl}/delete-bulk-students/?school_id=${opts.schoolId}`,
    {
      studentIds: opts.studentIds,
    },
  )
}

export const GetAllCourseTeams = (school_id: string, course_id: string) => {
  return myAxios.get(`${myCourseTeamUrl}/${school_id}/${course_id}/teams`)
}

export const GetStudentTeams = (
  school_id: string,
  course_id: string,
  user_id: string,
) => {
  return myAxios.get(
    `${myCourseTeamUrl}/${school_id}/${course_id}/myteams/student?user_id=${user_id}`,
  )
}

export const AddToTeam = (
  school_id: string,
  course_id: string,
  team_id: string,
  user_id: string,
) => {
  return myAxios.post(
    `${myCourseTeamUrl}/${school_id}/${course_id}/teams/${team_id}/join`,
    { user_id: user_id },
  )
}

export const RemoveFromTeam = (
  school_id: string,
  course_id: string,
  team_id: string,
  user_id: string,
) => {
  return myAxios.post(
    `${myCourseTeamUrl}/${school_id}/${course_id}/teams/${team_id}/leave`,
    { user_id: user_id },
  )
}

export const RequestTeam = (
  school_id: string,
  course_id: string,
  team_id: string,
  user_id: string,
) => {
  return myAxios.post(
    `${myCourseTeamUrl}/${school_id}/${course_id}/teams/${team_id}/request`,
    { user_id: user_id },
  )
}
export const GetCourseTeam = (
  school_id: string,
  course_id: string,
  team_id: string,
) => {
  return myAxios.get(
    `${myCourseTeamUrl}/${school_id}/${course_id}/teams/${team_id}`,
  )
}

export const AddTeam = (
  school_id: string,
  course_id: string,
  name: string,
  description: string,
) => {
  return myAxios.post(`${myCourseTeamUrl}/${school_id}/${course_id}/teams`, {
    name,
    description,
  })
}

export const EditTeam = (
  school_id: string,
  course_id: string,
  team_id: string,
  name: string,
  description: string,
) => {
  return myAxios.put(
    `${myCourseTeamUrl}/${school_id}/${course_id}/teams/${team_id}`,
    { name, description },
  )
}

export const ArchiveTeam = (
  school_id: string,
  course_id: string,
  team_id: string,
) => {
  return myAxios.put(
    `${myCourseTeamUrl}/${school_id}/${course_id}/teams/${team_id}/archive`,
  )
}

export const UnArchiveTeam = (
  school_id: string,
  course_id: string,
  team_id: string,
) => {
  return myAxios.put(
    `${myCourseTeamUrl}/${school_id}/${course_id}/teams/${team_id}/unarchive`,
  )
}

export const GetSchoolTimetableRequest = (school_id: String) => {
  return myAxios.get(`${myBaseUrl}/school-timetable/${school_id}`)
}

export const UpdateSchoolTimetableRequest = (
  school_id: String,
  timetable: Array<ITimetable>,
) => {
  const body = { timetable: timetable }
  return myAxios.put(
    `${myBaseAdminUrl}/school-timetable/${school_id}/?school_id=${school_id}`,
    body,
  )
}

export const updateCourseIndices = (school_id: string, content: any) => {
  const body = { content: content }
  const url = `${myBaseAdminUrl}/course_index/${school_id}?school_id=${school_id}`

  return myAxios.put(url, body)
}

// export const CheckIfUserAuthTokenIsValid = () => {
//   return myAxios.get(`${myBaseUrl}/check-auth-status/api/v1`);
// };

export const GetAllClassInSchool = (schoolId: string) => {
  return myAxios.get(`${myBaseSchoolUrl}/auth/api/v1/all-courses/${schoolId}`)
}

export const GetAllSchoolRequest = () => {
  return myAxios.get(`${myBaseSchoolAuthUrl}/all-schools/`)
}

export const SearchAllSchoolRequest = (searchQuery?: string) => {
  return myAxios.get(
    `${myBaseSchoolAuthUrl}/school_search/?searchQuery=${searchQuery}`,
  )
}

export const LoginUserWithGoogleAuthRequest = (tokenId: String) => {
  return myAxios.post(`${myBaseUsersUrl}/auth/login-google-auth/`, {
    tokenId: tokenId,
  })
}

export const LoginUserRequest = (opts: {
  email: String
  password?: String
  idToken?: String
  ignorePasswordValidation?: boolean
}) => {
  return myAxios.post(`${myBaseUsersUrl}/auth/login/`, {
    email: opts.email,
    password: opts.password,
    googleAuthToken: opts.idToken,
    ignorePasswordValidation: opts.ignorePasswordValidation,
  })
}

//verfify email
export const verifyUserEmail = (opts: { email: string }) => {
  return myAxios.post(`${myBaseUsersUrl}/auth/verify-user-exists/`, {
    email: opts.email,
  })
}

export const SignupUserRequest = (
  email: String,
  firstname: String,
  lastname: String,
  phoneNumber: String,
  country: String,
  password: String,
  referralSource: String,
) => {
  return myAxios.post(`${myBaseUsersUrl}/auth/register/`, {
    email: email,
    firstname: firstname,
    lastname: lastname,
    phone_number: phoneNumber,
    country: country,
    password: password,
    referralSource: referralSource,
  })
}

export const GetUserDetailsRequest = () => {
  return myAxios.get(`${myBaseUsersUrl}/user/user-details/`)
}

export const GetAccountUserSchoolBillingDetailsRequest = (schoolId: string) => {
  return myAxios.get(
    `${myBaseUsersUrl}/user/school-billing-details/${schoolId}`,
  )
}

export const UpdateAccountUserPlan = (
  schoolId: string,
  planName: AccountUserPlansType,
) => {
  const body = {
    school_id: schoolId,
    plan_name: planName,
  }

  return myAxios.put(
    `${myBaseUsersUrl}/user/school-billing-plan/${schoolId}`,
    body,
  )
}

// export const ChangeUserPlanRequest = (plan_name: string, plan_code: string) => {
//   let body = {
//     plan_name: plan_name,
//     plan_code: plan_code,
//   };
//   return myAxios.post(`${myBaseUsersUrl}/user/user-plan/`, body);
// };

export const GetAllSchoolFeesRequest = (
  school_id: string,
  searchQuery = '',
) => {
  return myAxios.get(
    `${myBaseUsersUrl}/school_fees/all/${school_id}?searchQuery=${searchQuery}`,
  )
}

export const PostNewSchoolFeesRequest = (
  school_id: string,
  reqBody: Omit<ISchoolFees, 'status'>,
) => {
  return myAxios.post(`${myBaseUsersUrl}/school_fees/log/${school_id}`, reqBody)
}

export const PostNewCouponRequest = (reqBody: any) => {
  return myAxios.post(`${myBaseCouponUrl}/school-coupon/`, reqBody)
}

export const FetchOrCreateStudentAffiliateCoupon = (opts: {
  percentageOff: number
  commission: number
  courseId: string
  studentId: string
}) => {
  const body = opts
  return myAxios.put(`${myBaseCouponUrl}/student-affiliate-coupons/`, body)
}

export const GetCouponRequest = (couponCode: string) => {
  return myAxios
    .get(`${myBaseCouponUrl}/all?coupon_code=${couponCode}`)
    .then(response => {
      return response.data
    })
}

export const ApplyCouponRequest = (reqBody: any) => {
  return myAxios.post(`${myBaseCouponUrl}/apply`, reqBody)
}
export const GetSchoolCouponRequest = (
  school_id: string,
  searchQuery: string = '',
) => {
  return myAxios.get(
    `${myBaseCouponUrl}/school-coupons/?school_id=${school_id}&searchQuery=${searchQuery}`,
  )
}

export const EditCouponRequest = (reqBody: any) => {
  return myAxios.put(`${myBaseCouponUrl}/update`, reqBody)
}

export const DeleteCoupon = (id: string) => {
  return myAxios.delete(`${myBaseCouponUrl}/delete-coupon/?coupon_id=${id}`)
}
export const GetSchoolFeesBasedOnEmailRequest = (
  school_id: string,
  email: string,
) => {
  return myAxios.get(
    `${myBaseUsersUrl}/school_fees/email/${school_id}?email=${email}`,
  )
}

export const GetListOfBanksRequest = () => {
  return myAxios.get(`${myBaseUsersUrl}/school_fees/bank_list/`)
}

export const CreateSchoolRequest = (
  name: String,
  schoolUrl: String,
  tagline: String,
  logo: String,
  color_scheme: IColorScheme,
  email: String,
  phone: String,
  school_kind: String,
  school_type?: string,
) => {
  const body: any = {
    name: name,
    school_url: schoolUrl,
    tagline: tagline,
    logo: logo,
    color_scheme: color_scheme,
    email: email,
    phone_number: phone,
    school_kind: school_kind,
  }

  if (school_type) {
    body.school_type = school_type
  }

  return myAxios.post(`${myBaseSchoolUrl}/schools/create`, body)
}

export const EditSchoolRequest = (schoolId: String, schoolDetails: ISchool) => {
  return myAxios.put(
    `${myBaseAdminUrl}/schools/update/${schoolId}/?school_id=${schoolId}`,
    {
      ...schoolDetails,
    },
  )
}

export const ChangeSchoolPlanRequest = (
  schoolId: String,
  plan_name: String,
  plan_code: String,
  authorization_code: String,
) => {
  return myAxios.put(`${myBaseSchoolUrl}/schools/update-plan/${schoolId}`, {
    plan_name: plan_name,
    school_id: schoolId,
    plan_code: plan_code,
    paystack_authorization: authorization_code,
  })
}

export const UpdateSchoolMailTemplateRequest = (
  schoolId: String,
  mail_template: any,
) => {
  return myAxios.put(
    `${myBaseAdminUrl}/schools/update-mail-template/${schoolId}/?school_id=${schoolId}`,
    {
      mail_template: mail_template,
    },
  )
}

export const GetSchoolMailTemplateRequest = (schoolId: String) => {
  return myAxios.get(
    `${myBaseAdminUrl}/schools/mail-template/${schoolId}/?school_id=${schoolId}`,
  )
}

export const RegisterStudentRequest = (
  name: String,
  email: String,
  schoolId: String,
  schoolNo: String,
  password: String,
) => {
  return myAxios.post(`${myBaseUrl}/schools/auth/api/v1/students/register/`, {
    name: name,
    email: email,
    school_id: schoolId,
    school_no: schoolNo,
    password: password,
  })
}

export const GetUserCreatedSchoolList = () => {
  return myAxios.get(`${myBaseSchoolUrl}/schools/`)
}

export const GetUserSchoolLiveClass = () => {
  return myAxios.get(`${myBaseSchoolUrl}/school-live-class/`)
}

export const SearchForSchool = (searchQuery: String) => {
  return myAxios.get(
    `${myBaseSchoolUrl}/search-for-school?searchQuery=${searchQuery}`,
  )
}

export const GetSchoolDetailsForAdmin = (schoolId: String) => {
  return myAxios.get(
    `${myBaseAdminUrl}/schools/${schoolId}/?school_id=${schoolId}`,
  )
}

export const GetAdminList = (schoolId: String) => {
  return myAxios.get(`${myBaseAdminUrl}/admins/?school_id=${schoolId}`)
}

export const SearchForSchoolUrl = (schoolUrl: String) => {
  return myAxios.get(
    `${myBaseSchoolUrl}/schools/search-for-school-url?school_url=${schoolUrl}`,
  )
}

export const CheckIfSchoolUrlExistRequest = (schoolUrl: String) => {
  return myAxios.get(
    `${myBaseSchoolAuthUrl}/search-for-school-url?&school_url=${schoolUrl}`,
  )
}

export const PostCreateAdmin = (
  name: String,
  email: String,
  phoneNumber: String,
  password: String,
  schoolNo: String,
  schoolId: String,
) => {
  return myAxios.post(`${myBaseAdminUrl}/admins/?school_id=${schoolId}`, {
    name: name,
    email: email,
    phone_number: phoneNumber,
    password: password,
    school_no: schoolNo,
  })
}

export const DeleteAdminRequest = (adminId: String, schoolId: String) => {
  return myAxios.delete(
    `${myBaseAdminUrl}/admins/${adminId}/?school_id=${schoolId}`,
  )
}

export const UpdateAdminRequest = (opts: {
  name: string
  email: string
  phoneNumber: string
  adminId: string
  schoolId: string
  enableNotifications: boolean
}) => {
  return myAxios.put(
    `${myBaseAdminUrl}/admins/${opts.adminId}/?school_id=${opts.schoolId}`,
    {
      name: opts.name,
      email: opts.email,
      phone_number: opts.phoneNumber,
      enable_notifications: opts.enableNotifications,
    },
  )
}

export const ChangeSchoolBackgroundImage = (
  schoolId: String,
  backgroundImage: String | undefined,
) => {
  return myAxios.put(
    `${myBaseAdminUrl}/schools/update-background/${schoolId}/?school_id=${schoolId}`,
    {
      background_image: backgroundImage,
    },
  )
}

export const GetPendingStudentListRequest = (
  schoolId: String,
  searchQuery: string = '',
) => {
  return myAxios.get(
    `${myBaseAdminUrl}/students/pending?school_id=${schoolId}&searchQuery=${searchQuery}`,
  )
}

export const GetPendingTeacherListRequest = (
  schoolId: String,
  searchQuery: string = '',
) => {
  return myAxios.get(
    `${myBaseAdminUrl}/teachers/pending?school_id=${schoolId}&searchQuery=${searchQuery}`,
  )
}

export const GetDeletedStudentListRequest = (
  schoolId: String,
  searchQuery: string = '',
) => {
  return myAxios.get(
    `${myBaseAdminUrl}/students/deleted?school_id=${schoolId}&searchQuery=${searchQuery}`,
  )
}

export const GetDeletedTeacherListRequest = (
  schoolId: String,
  searchQuery: string = '',
) => {
  return myAxios.get(
    `${myBaseAdminUrl}/teachers/deleted?school_id=${schoolId}&searchQuery=${searchQuery}`,
  )
}

export const GetDeletedAdminListRequest = (
  schoolId: String,
  searchQuery: string = '',
) => {
  return myAxios.get(
    `${myBaseAdminUrl}/admins/deleted?school_id=${schoolId}&searchQuery=${searchQuery}`,
  )
}

export const PostNewStudentRequest = (
  name: String,
  email: String,
  schoolId: String,
) => {
  return myAxios.post(`${myBaseAdminUrl}/students/?school_id=${schoolId}`, {
    name: name,
    email: email,
  })
}

export const DeleteStudentRequest = (studentId: String, schoolId: String) => {
  return myAxios.delete(
    `${myBaseAdminUrl}/students/${studentId}/?school_id=${schoolId}`,
  )
}

export const UnDeleteStudentRequest = (studentId: String, schoolId: String) => {
  return myAxios.put(
    `${myBaseAdminUrl}/students/undelete/${studentId}?school_id=${schoolId}`,
    {},
  )
}

export const UnDeleteTeacherRequest = (studentId: String, schoolId: String) => {
  return myAxios.put(
    `${myBaseAdminUrl}/teachers/undelete/${studentId}?school_id=${schoolId}`,
    {},
  )
}

export const UnDeleteAdminRequest = (adminId: String, schoolId: String) => {
  return myAxios.put(
    `${myBaseAdminUrl}/admins/undelete/${adminId}?school_id=${schoolId}`,
    {},
  )
}

export const UpdateStudentRequest = (
  name: String,
  email: String,
  studentId: String,
  schoolId: String,
) => {
  return myAxios.put(
    `${myBaseAdminUrl}/students/${studentId}?school_id=${schoolId}`,
    { student_name: name, student_email: email },
  )
}

export const GetTeacherListRequest = (
  schoolId: String,
  searchQuery: string = '',
) => {
  return myAxios.get(
    `${myBaseAdminUrl}/teachers?school_id=${schoolId}&searchQuery=${searchQuery}`,
  )
}

export const GetSchoolCourseListRequest = (
  schoolId: String,
  searchQuery: string = '',
) => {
  return myAxios.get(
    `${myBaseAdminUrl}/courses?school_id=${schoolId}&searchQuery=${searchQuery}`,
  )
}

export const PostNewTeacherRequest = (opts: {
  name: String
  email: String
  password: string
  schoolId: String
  customAuthInput: any
}) => {
  return myAxios.post(`${myBaseAdminUrl}/teachers?school_id=${opts.schoolId}`, {
    name: opts.name,
    email: opts.email,
    custom_auth_input: opts.customAuthInput,
    password: opts.password,
  })
}

export const DeleteTeacherRequest = (teacherId: String, schoolId: String) => {
  return myAxios.delete(
    `${myBaseAdminUrl}/teachers/${teacherId}?school_id=${schoolId}`,
  )
}

export const UpdateTeacherRequest = (
  name: String,
  email: String,
  studentId: String,
  schoolId: String,
  canCreateCourse: Boolean,
) => {
  return myAxios.put(
    `${myBaseAdminUrl}/teachers/${studentId}?school_id=${schoolId}`,
    { name: name, email: email, can_create_course: canCreateCourse },
  )
}

export const ResetTeacherPasswordRequest = (
  teacherId: String,
  userCode: string,
  name: String,
  email: string,
  schoolId: String,
) => {
  return myAxios.put(
    `${myBaseAdminUrl}/reset-password/teachers/${teacherId}?school_id=${schoolId}`,
    { name: name, email: email, user_code: userCode },
  )
}

export const ResetAdminPasswordRequest = (
  adminId: String,
  userCode: string,
  name: String,
  email: string,
  schoolId: String,
) => {
  return myAxios.put(
    `${myBaseAdminUrl}/reset-password/admins/${adminId}?school_id=${schoolId}`,
    { name: name, email: email, user_code: userCode },
  )
}

export const ResetStudentPasswordRequest = (
  studentId: String,
  userCode: string,
  name: String,
  email: string,
  schoolId: String,
) => {
  return myAxios.put(
    `${myBaseAdminUrl}/reset-password/students/${studentId}?school_id=${schoolId}`,
    { name: name, email: email, user_code: userCode },
  )
}

export const ApprovePendingStudentRequest = (
  studentId: String,
  schoolId: String,
) => {
  return myAxios.post(
    `${myBaseAdminUrl}/students/approve-pending/${studentId}?school_id=${schoolId}`,
    {},
  )
}

export const DeletePendingStudentRequest = (
  studentId: String,
  schoolId: String,
) => {
  return myAxios.delete(
    `${myBaseAdminUrl}/students/pending/${studentId}?school_id=${schoolId}`,
  )
}

export const ApprovePendingTeacherRequest = (
  studentId: String,
  schoolId: String,
) => {
  return myAxios.post(
    `${myBaseAdminUrl}/teachers/approve-pending/${studentId}?school_id=${schoolId}`,
    {},
  )
}

export const DeletePendingTeacherRequest = (
  studentId: String,
  schoolId: String,
) => {
  return myAxios.delete(
    `${myBaseAdminUrl}/teachers/pending/${studentId}?school_id=${schoolId}`,
  )
}

export const GetUserCreditBalance = () => {
  return myAxios.get(`${myBaseUsersUrl}/credits/balance/`)
}

export const GetCreditPrices = () => {
  return myAxios.get(`${myBaseUsersUrl}/credits/credit-prices/`)
}

export const GetTransactionsLogs = () => {
  return myAxios.get(`${myBaseUsersUrl}/transactions/logs/`)
}

export const GetCustomDomainTxtRecord = (
  domainName: String,
  schoolId: String,
  schoolUrl: String,
) => {
  return myAxios.get(
    `
    ${myBaseCustomDomainUrl}/domain-txt-record/?school_id=${schoolId}&&domain_name=${domainName}&&school_url=${schoolUrl}`,
  )
}

export const DeleteCustomDomainTxtRecord = (schoolId: String) => {
  return myAxios.delete(
    `${myBaseCustomDomainUrl}/domain/?school_id=${schoolId}`,
  )
}

export const AddCustomDomainTxtRecord = (
  schoolId: String,
  domainName: String,
  txtName: String,
  txtValue: String,
  schoolUrl: String,
) => {
  const body = {
    domain_name: domainName,
    TXT_NAME: txtName,
    TXT_VALUE: txtValue,
    school_url: schoolUrl,
  }
  return myAxios.post(
    `${myBaseCustomDomainUrl}/domain/?school_id=${schoolId}`,
    body,
  )
}

export const AddNewCourseRequest = (
  schoolId: String,
  schoolNo: String,
  teacherId: String,
  courseName: String,
  courseDesc: String,
  courseDept: String,
  courseUnit: String,
  isPublic: Boolean,
) => {
  const body = {
    course_teacher_id: teacherId,
    course_name: courseName,
    course_description: courseDesc,
    course_department: courseDept,
    course_unit: courseUnit,
    course_isPublic: isPublic,
  }
  return myAxios.post(
    `${myBaseAdminUrl}/courses?school_id=${schoolId}&&school_no=${schoolNo}`,
    body,
  )
}

export const AddTeacherToCourseRequest = (
  teacherId: String,
  courseId: String,
  schoolId: String,
) => {
  const body = {
    course_id: courseId,
    teacher_id: teacherId,
  }
  return myAxios.put(
    `${myBaseAdminUrl}/course_teachers?school_id=${schoolId}`,
    body,
  )
}

export const RemoveTeacherFromCourseRequest = (
  teacherId: String,
  courseId: String,
  schoolId: String,
) => {
  return myAxios.delete(
    `${myBaseAdminUrl}/course_teachers/${courseId}/teachers/${teacherId}?school_id=${schoolId}`,
  )
}

export const GetCourseRequest = (schoolId: String) => {
  return myAxios.get(`${myBaseAdminUrl}/courses/?school_id=${schoolId}`)
}

export const DeleteCourseRequest = (courseId: String, schoolId: String) => {
  return myAxios.delete(
    `${myBaseAdminUrl}/courses/${courseId}?school_id=${schoolId}`,
  )
}

export const AddStudentToCourseRequest = (
  schoolId: String,
  schoolNo: String,
  studentId: String,
  studentName: String,
  studentUserCode: String,
  studentEmail: String,
  courseId: String,
  courseCode: String,
) => {
  const body = {
    school_id: schoolId,
    course_id: courseId,
    course_code: courseCode,
    student_id: studentId,
    student_name: studentName,
    student_user_code: studentUserCode,
    student_email: studentEmail,
  }
  return myAxios.post(
    `${myBaseAdminUrl}/course_students?school_id=${schoolId}&school_no=${schoolNo}`,
    body,
  )
}

export const GetCourseStudentRequest = (schoolId: String, courseId: String) => {
  return myAxios.get(
    `${myBaseAdminUrl}/course_students/${courseId}?school_id=${schoolId}`,
  )
}

export const DeleteCourseStudentsRequest = (
  courseId: String,
  studentId: String,
  schoolId: String,
) => {
  return myAxios.delete(
    `${myBaseAdminUrl}/course_students/${courseId}/students/${studentId}?school_id=${schoolId}`,
  )
}

export const PostUserCodeForResetPasswordRequest = (email: String) => {
  return myAxios.post(`${myBaseUsersUrl}/auth/reset-password/`, {
    email: email,
  })
}

export const CreateNewPasswordFromTokenRequest = (
  email: String,
  token: String,
  password: String,
) => {
  return myAxios.post(`${myBaseUsersUrl}/auth/create-password/`, {
    email: email,
    token: token,
    password: password,
  })
}

// for single classes
export const CreateClassRequest = (name: String, description: string) => {
  return myAxios.post(`${myBaseClassUrl}/create`, {
    name: name,
    description: description,
  })
}

export const EditClassRequest = (
  _id: string,
  name: String,
  description: string,
) => {
  return myAxios.put(`${myBaseClassUrl}/update-class/${_id}`, {
    name: name,
    description: description,
  })
}

export const GetClassListRequest = () => {
  return myAxios.get(`${myBaseClassUrl}/`)
}

export const GetStudentsInClassRequest = (class_id: string) => {
  return myAxios.get(`${myBaseClassUrl}/student-list/${class_id}`)
}

export const AddStudentToSingleClassRequest = (
  studentName: String,
  studentEmail: String,
  studentPassword: String,
  courseId: String,
) => {
  const body = {
    name: studentName,
    email: studentEmail,
    password: studentPassword,
    course_id: courseId,
  }
  return myAxios.post(`${myBaseClassUrl}/add-students`, body)
}

export const GetSchoolAnalyticsRequest = (
  schoolId: String,
  start_date: any = false,
  end_date: any = false,
) => {
  return myAxios.get(
    `${myBaseAdminUrl}/school-analytics?school_id=${schoolId}&start_date=${start_date}&end_date=${end_date}`,
  )
}

export const GetAllPlansRequest = () => {
  return myAxios.get(`${myBaseUsersUrl}/user/plan_list/`)
}

export const GetSchoolDetailsFromUrl = (schoolUrl: String) => {
  return myAxios.get(
    `${myBaseSchoolAuthUrl}/school-details-from-url/${schoolUrl}`,
  )
}

export const GetAllClassInFindSchool = (schoolId: string) => {
  return myAxios.get(`${myBaseSchoolAuthUrl}/all-courses/${schoolId}`)
}

export const GetSchoolCategoriesRequest = (schoolId: String) => {
  return myAxios.get(
    `${myBaseAdminUrl}/school-categories/${schoolId}/?school_id=${schoolId}`,
  )
}

export const CreateSchoolCategoriesRequest = (
  schoolId: String,
  name: string,
  description: string,
  isPublic: boolean,
) => {
  const body = {
    name: name,
    description: description,
    isPublic: isPublic,
  }
  return myAxios.post(
    `${myBaseAdminUrl}/school-categories/${schoolId}/?school_id=${schoolId}`,
    body,
  )
}

export const UpdateSchoolCategoriesRequest = (
  schoolId: String,
  categoryId: String,
  name: string,
  description: string,
  isPublic: boolean,
) => {
  const body = {
    name: name,
    description: description,
    isPublic: isPublic,
  }
  return myAxios.put(
    `${myBaseAdminUrl}/school-categories/${schoolId}/${categoryId}/?school_id=${schoolId}`,
    body,
  )
}

export const UpdateSchoolCategoriesIndexRequest = (
  schoolId: String,
  category_indices: Array<{ category_id: string; index: number }>,
) => {
  const body = {
    category_indices,
  }
  return myAxios.put(
    `${myBaseAdminUrl}/school-categories/index/${schoolId}/?school_id=${schoolId}`,
    body,
  )
}

export const DeleteSchoolCategoriesRequest = (
  schoolId: String,
  category_id: String,
) => {
  return myAxios.delete(
    `${myBaseAdminUrl}/school-categories/${schoolId}/${category_id}/?school_id=${schoolId}`,
  )
}

export const AddCourseToSchoolCategoriesRequest = (
  school_id: String,
  category_id: String,
  course_id: String,
) => {
  const body = {}
  return myAxios.put(
    `${myBaseAdminUrl}/school-course-categories/${course_id}/${category_id}/?school_id=${school_id}`,
    body,
  )
}

export const DeleteCourseFromSchoolCategoriesRequest = (
  school_id: String,
  category_id: String,
  courseId: String,
) => {
  return myAxios.delete(
    `${myBaseAdminUrl}/school-course-categories/${courseId}/${category_id}/?school_id=${school_id}`,
  )
}

export const GetUserSingleClassListRequest = () => {
  return myAxios.get(`${myBaseSchoolUrl}/single_class_list`)
}

export const getCourseDetails = (course_id: string) => {
  return myAxios.get(`${myBaseAdminTeacherUrl}/courses/details/${course_id}`)
}

export const GetStudentCoursesRequest = (
  school_id?: string,
  student_id?: string,
) => {
  return myAxios.get(
    `${myBaseAdminUrl}/students/${student_id}/courses/?school_id=${school_id}`,
  )
}

export const GetTeacherCoursesRequest = (
  school_id: string,
  teacher_id: string,
) => {
  return myAxios.get(
    `${myBaseAdminUrl}/teachers/${teacher_id}/courses/?school_id=${school_id}`,
  )
}

export const SearchForCourseTemplateRequest = (query: string) => {
  return myAxios.get(
    `${myBaseSchoolAuthUrl}/search-course-templates?&searchQuery=${query}`,
  )
}

// export const CreateCourseTemplateRequest = (
//   name: string,
//   description: string,
//   tags: string,
//   content: Array<any>
// ) => {
//   let body = {
//     name: name,
//     description: description,
//     tags: tags,
//     content: content
//   };
//   return myAxios.post(`${myBaseSchoolUrl}/course-templates`, body, );
// };

// export const UpdateCourseTemplateRequest = (
//   template_id: string,
//   name: string,
//   description: string,
//   tags: string,
//   content: Array<any>
// ) => {
//   let body = {
//     name: name,
//     description: description,
//     tags: tags,
//     content: content
//   };
//   return myAxios.put(
//     `${myBaseSchoolUrl}/course-templates/${template_id}`,
//     body,
//
//   );
// };

// export const DeleteCourseTemplateRequest = (template_id: string) => {
//   return myAxios.delete(
//     `${myBaseSchoolUrl}/course-templates/${template_id}`,
//
//   );
// };

export const GetCourseTemplateDetailsRequest = (template_id: string) => {
  return myAxios.get(`${myBaseSchoolAuthUrl}/course-templates/${template_id}`)
}

// export const GetUserCourseTemplatesRequest = () => {
//   return myAxios.get(`${myBaseSchoolUrl}/user-course-templates`, );
// };

export const CreateNewCourseFromTemplateRequest = (
  school_id: string,
  school_no: string,
  course_template_id: string,
) => {
  let body = {
    school_id: school_id,
    school_no: school_no,
    course_template_id: course_template_id,
  }
  return myAxios.post(
    `${myBaseAdminUrl}/course-from-template?school_id=${school_id}`,
    body,
  )
}

export const CreateTemplateFromCourseRequest = (course_id: string) => {
  let body = {
    course_id: course_id,
  }
  return myAxios.post(`${myBaseSchoolUrl}/template-from-course`, body)
}

export const UpdateSignupFieldsRequest = (
  school_id: string,
  fields: Array<{ fieldName: string }>,
) => {
  let body = {
    custom_auth_input: fields,
  }
  return myAxios.post(
    `${myBaseAdminUrl}/school-custom-auth-input/${school_id}/?school_id=${school_id}`,
    body,
  )
}

export const AddSchoolLog = (
  school_id: string,
  user_id: string,
  user_type: string,
  course_id?: string,
) => {
  const body = {
    action: 'ACCOUNT_VISIT',
    url: location.href,
    school_id: school_id,
    school_path: location.href,
    user_id: user_id,
    user_type: user_type,
    course_id: course_id,
  }

  return myAxios.post(`${myBaseUrl}/analytics/v1`, body)
}

export const GetSchoolMailGroups = (
  school_id: string,
  query: string = '',
  startDate: string = '',
  endDate: string = '',
) => {
  return myAxios.get(
    `${myBaseMarketingUrl}/${school_id}/mail-groups/?search_query=${query}&start_date=${startDate}&end_date=${endDate}`,
  )
}

export const SendSchoolMailRequest = (
  schoolId: string,
  recipients: any,
  sender: string | undefined,
  mail_template: {
    message: string
    subject: string
    from_email: string
    display_name: string
  },
) => {
  return myAxios.post(
    `${myBaseUrl}/schools/communications/api/v1/${schoolId}/send-mails`,

    { recipients, sender, mail_template },
  )
}

export const getFilteredStudentsInSchool = (
  school_id: string,
  searchQuery?: string,
  startDate?: string,
  endDate?: string,
  atLeastOnePayment?: boolean,
  noPayments?: boolean,
  byCourse?: Array<string>,
  courseApproved?: boolean,
) => {
  let body: any = { school_id }

  if (searchQuery) {
    body.searchQuery = searchQuery
  }

  if (startDate && endDate) {
    body.startDate = startDate

    body.endDate = endDate
  }

  if (atLeastOnePayment) {
    body.atLeastOnePayment = atLeastOnePayment
  }

  if (noPayments) {
    body.noPayments = noPayments
  }

  if (byCourse) {
    body.byCourse = byCourse
  }

  if (courseApproved) {
    body.courseApproved = courseApproved
  }

  return myAxios.post(`${myBaseUrl}/schools/v2/students/filters`, body)
}

export const GetSchoolTestimonials = () => {
  return myAxios.get(`${myBaseUrl}/testimonials/v2/school-testimonials`)
}

export const CreateSchoolTestimonial = (
  name: string,
  testimonial: string,
  job_title: string,
  image: string,
) => {
  const body = {
    name,
    testimonial,
    job_title,
    image_url: image,
  }

  return myAxios.post(`${myBaseUrl}/testimonials/v2/school-testimonials`, body)
}

export const DeleteSchoolTestimonial = (id: string) => {
  return myAxios.delete(
    `${myBaseUrl}/testimonials/v2/school-testimonials/${id}`,
  )
}

export const UpdateSchoolTestimonial = ({
  name,
  testimonial,
  job_title,
  image_url,
  id,
}: any) => {
  const body = {
    name,
    testimonial,
    job_title,
    image_url,
  }

  return myAxios.put(
    `${myBaseUrl}/testimonials/v2/school-testimonials/${id}`,
    body,
  )
}

export const FetchSchoolMailchimpDetailsRequest = (opts: {
  schoolId: string
}) => {
  return myAxios.get(
    `${myBaseAdminUrl}/schools-mailchimp-conf/${opts.schoolId}`,
  )
}

export const SyncAllMailchimpDataRequest = (opts: { schoolId: string }) => {
  return myAxios.post(
    `${myBaseAdminUrl}/schools-mailchimp-conf-sync-all/${opts.schoolId}`,
  )
}

export const UpdateSchoolMailchimpDetailsRequest = (opts: {
  schoolId: string
  mailchimpApiKey: string
  mailchimpUrl: string
  mailchimpAudienceId: string
  enabled: boolean
}) => {
  const body = {
    mailchimp_api_key: opts.mailchimpApiKey,
    mailchimp_url: opts.mailchimpUrl,
    mailchimp_audience_id: opts.mailchimpAudienceId,
    enabled: opts.enabled,
  }
  return myAxios.put(
    `${myBaseAdminUrl}/schools-mailchimp-conf/${opts.schoolId}`,
    body,
  )
}

export const GenerateSchoolApiKeyRequest = (opts: { schoolId: string }) => {
  const body = {}
  return myAxios.post(
    `${myBaseAdminUrl}/public-api-keys/${opts.schoolId}`,
    body,
  )
}

export const DeleteSchoolApiKeyRequest = (opts: {
  schoolId: string
  apiKeyId: string
}) => {
  return myAxios.delete(
    `${myBaseAdminUrl}/public-api-keys/${opts.schoolId}/${opts.apiKeyId}`,
  )
}

export const GetSchoolApiKeysRequest = (opts: { schoolId: string }) => {
  return myAxios.get(`${myBaseAdminUrl}/public-api-keys/${opts.schoolId}`)
}
